module.exports = __webpack_public_path__ + "assets/1f2f105053a7d9eacdc460b45f88bb77.png";